/**
 * 内閣府参照 日本の祝日
 * https://www8.cao.go.jp/chosei/shukujitsu/gaiyou.html
 */
export const HOLIDAYS = [
  "2022/1/1",
  "2022/1/10",
  "2022/2/11",
  "2022/2/23",
  "2022/3/21",
  "2022/4/29",
  "2022/5/3",
  "2022/5/4",
  "2022/5/5",
  "2022/7/18",
  "2022/8/11",
  "2022/9/19",
  "2022/9/23",
  "2022/10/10",
  "2022/11/3",
  "2022/11/23",
  "2022/12/28",
  "2022/12/29",
  "2022/12/30",
  "2023/1/1",
  "2023/1/2",
  "2023/1/9",
  "2023/2/11",
  "2023/2/23",
  "2023/3/21",
  "2023/4/29",
  "2023/5/3",
  "2023/5/4",
  "2023/5/5",
  "2023/7/17",
  "2023/8/11",
  "2023/9/18",
  "2023/9/23",
  "2023/10/9",
  "2023/11/3",
  "2023/11/23",
  "2024/1/1",
  "2024/1/8",
  "2024/2/11",
  "2024/2/12",
  "2024/2/23",
  "2024/3/20",
  "2024/4/29",
  "2024/5/3",
  "2024/5/4",
  "2024/5/5",
  "2024/5/6",
  "2024/7/15",
  "2024/8/11",
  "2024/8/12",
  "2024/9/16",
  "2024/9/22",
  "2024/9/23",
  "2024/10/14",
  "2024/11/3",
  "2024/11/4",
  "2024/11/23"
];
